<template>
  <luma-empty>
    <b-card >
       <b-btn variant="outline-success"
              class="float-right col-12"
              @click="createNewHandle=!createNewHandle">
         {{ !createNewHandle ? 'Neuen Handle anlegen' : 'Zurück'}}
       </b-btn>
    </b-card>

    <luma-create-handle v-if="createNewHandle" @emitSuccess="emitSuccess"></luma-create-handle>

    <b-card v-if="!createNewHandle">
            <luma-table url="domain/handles" :columns="columns" :model="handle" >
              <template v-slot:actions="slotProps">
                <b-button variant="white small" size="xs" :to="{name: 'domain-handle-single', params: { handle: slotProps.item.handle }}">Bearbeiten</b-button>
              </template>
            </luma-table>
    </b-card>
  </luma-empty>
</template>

<script>
  import LumaEmpty from "@/layout/LumaEmpty"
  import LumaDatatable from "@/components/LumaDatatable"
  import DomainHandle from "@/store/models/domain/domain_handle"
  import LumaCreateHandle from "./luma-create-handle";

  export default {
    name: "domain-handle-list",
    components: {
        LumaCreateHandle,
        LumaEmpty,
        'luma-table': LumaDatatable
    },
    data: () => ({
      handle: DomainHandle,
      customFilter: null,
        createNewHandle:false
    }),
      methods:{
        emitSuccess(val){
          console.log(val)
          this.createNewHandle = false
        }
      },
      computed:{
          columns(){
              const headers = ['handle', 'type', 'organisation','firstname','lastname','user','actions']
              return headers.map(el=>({
                      key:el,
                      column:el,
                      filter:true,
                      order:true,
                      slot: el === 'actions' ? true : false
                      //format: el!=='tld'?'currency':''
                  }
              ))

          }
      }
  }
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: relative;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/domain/handles_domain/DomainHandleList.vue